import * as React from 'react';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import If from '../../../../If/If';

export async function discountEditPopUp(discounted: boolean) {
	return newConfirmModal(
		'Notice',
		<div className="edit-booking-modal">
			<If condition={discounted}>
				<h5>
					As you have a <strong>discount</strong> applied to your booking, you will be{' '}
					<strong>restricted</strong> with what you can alter.
				</h5>
			</If>
		</div>,
		{
			cancelText: 'Back',
			confirmText: 'Continue',
			resolveOnCancel: true,
			shouldCloseOnEsc: false,
			shouldCloseOnOverlayClick: false,
		},
	);
}
